const MasterPage = () => {
    return (
        <>
            <h1>Master Works</h1>
        </>
    );
}
 
export default MasterPage;